<template>
  <div class="download-box">
    <div class="item" v-for="(item, index) in downloadData" :key="index">
      <div class="box">
        <img :src="$utils.getPng('web4/dl_icon' + item.id)" />
        <span class="name">{{ $t(item.name) }}</span>
        <span @click="onClike(item)" class="btn">{{ $t('home.DownloadNow') }}</span>
      </div>
      <div class="box2">
        <div class="imgBox">
          <!-- <img class="ewm" :src="$utils.getPng('downapp')" /> -->
          <div class="ewm" :id="'qrcode5_3' + index"></div>
        </div>
        <div class="tit1">{{ $t('home.ScanQRcodedownload') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { clientDownUrlAPI } from "@/utils/apiList/home";
export default {
  data() {
    return {
      downloadData: [
        { id: 1, name: "home.AndroidClient" },
        { id: 2, name: "home.iOSClient" },
        { id: 3, name: "home.WindowsDesktop" },
        { id: 4, name: "home.MacOSDesktop" },
      ],
    };
  },
  created(){
    this.Dow()
  },
  mounted() {
    this.createCode();
  },
  methods: {
    //生成APP下载二维码
    async createCode() {
      // 1.创建二维码对象。qrcode(二维码类型（1~40，输入 0 以自动检测）,容错级别（L、M、Q、H）)

      await this.clearQRCode(); // Asynchronous clear
      // createImgTag(cellSize, margin, alt); cellSize 像素宽度,margin补白像素宽度
      this.$nextTick(() => {
        var qr = qrcode(0, "L");
        // 2.添加二维码信息。
        qr.addData(this.$glb.fmoverseas + '/wap.html');
        // 3.生成二维码对象（并不显示）。
        qr.make();
        document.getElementById("qrcode5_30").innerHTML = qr.createImgTag(4, 0);
        document.getElementById("qrcode5_31").innerHTML = qr.createImgTag(4, 0);
        
      });
    },
    async clearQRCode() {
      return new Promise((resolve) => {
        document.getElementById("qrcode5_30").innerHTML = "";
        document.getElementById("qrcode5_31").innerHTML = "";
        resolve();
      });
    },
    //桌面端下载
    onClike(item) {
      if (item.id == 3) {
        // 创建链接元素
        var link = document.createElement("a");
        link.href = this.exe.win_url;
        link.download = "";
        // 模拟点击链接以下载文件
        link.click();
      } else if (item.id == 4) {
        // 创建链接元素
        var link = document.createElement("a");
        link.href = this.exe.mac_url;
        link.download = "";
        // 模拟点击链接以下载文件
        link.click();
      }
    },
    Dow() {
      try {
        clientDownUrlAPI().then((res) => {
          this.exe = res?.data;
        });
      } catch (error) {
        // 处理异常
        console.error(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
